'use strict';

/**
 * Send a notification (toast message)
 * @param {string} message message to display
 * @param {('info'|'success'|'warning'|'danger'|'error')=} status - default danger
 * @param {string=} selector selector of the element to display the message
 * @param {{label:string,eventName:string,popinProps:Object}=} buttonData optional button data
 * @returns {void}
 */
function send(message, status, selector, buttonData) {
    if (!message) {
        return;
    }

    status = status || 'danger';
    status = status === 'error' ? 'danger' : status;
    selector = selector || '.notif-messaging';
    let buttonHtml = '';
    const uniqueId = `btn_notif_${Math.random().toString(36).slice(2, 9)}`;
    if (buttonData) {
        buttonHtml = `
            <button id="${uniqueId}" type="button" class="btn-sm btn-style-9">
                ${buttonData.label}
            </button>
        `;
    }
    const notifHtml = '<div class="alert alert-' + status + ' alert-dismissible '
        + 'fade show" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span>'
        + '</button><div class="popin-text mb-2">'
        + message
        + '</div>'
        + buttonHtml
        + '</div>';

    const el = document.querySelector(selector);
    el.append(document.createRange().createContextualFragment(notifHtml));

    if (buttonData) {
        let btn = document.getElementById(uniqueId);
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            window.dispatchEvent(new CustomEvent(buttonData.eventName, { detail: buttonData.popinProps }));
            btn.parentElement.remove();
        });
    }
}

module.exports = {
    send: send
};
